import { Box, HStack, Icon, Text, VStack, makeUclComponent } from '@rbilabs/universal-components';

import ActionButton, { ActionButtonVariants } from 'components/action-button';
import { theme } from 'styles/configure-theme';
import { hiddenAccessibilityPlatformProps } from 'utils/accessibility';

export const StyledIcon = Icon.withConfig({
  size: '5',
  mr: '$1',
  ...hiddenAccessibilityPlatformProps,
});

export const Card = HStack.withConfig({
  backgroundColor: theme.token('background-pattern'),
  borderRadius: 'lg',
  paddingY: '$4',
  paddingX: '$5',
  width: 'full',
  height: 'full',
  alignItems: 'center',
  flex: 1,
});

export const CardContainer = Box.withConfig({
  marginX: { base: '$4', md: 0 },
  height: '$40',
});

export const OrderNumber = Text.withConfig({
  variant: 'copyOne',
  marginBottom: '$4',
  color: 'textDisabled',
  minHeight: '$4',
});

export const LeftContainer = VStack.withConfig({
  flex: { base: 0.7, md: 0.8 },
  height: 'full',
  alignSelf: 'baseline',
});

export const RightContainer = VStack.withConfig({
  flex: { base: 0.3, md: 0.2 },
  alignItems: 'flex-end',
});

export const ServiceModeContainer = HStack.withConfig({
  alignItems: 'center',
});

export const ServiceModeLabel = Text.withConfig({
  fontFamily: 'heading',
});

export const StyledText = Text.withConfig({
  fontSize: 'md',
});

export const ActionButtonStyled = makeUclComponent(ActionButton).withConfig({
  variant: ActionButtonVariants.OUTLINE,
  mt: '$4',
  w: { base: '120px', md: 'full' },
  p: '$2',
  h: '$10',
});
